import { Auth } from 'aws-amplify'

export const changePassword = async username => {
  return Auth.forgotPassword(username)
}

export const newPassword = async ({ username, code, nPassword }) => {
  return Auth.forgotPasswordSubmit(username, code, nPassword)
}
